// import React from 'react'
// import UpperPic1 from "../assets/ninthSection-pic1.jpg"
// import UpperPic2 from "../assets/ninthSection-pic2.jpg"
// import UpperPic3 from "../assets/ninthSection-pic3.jpg"
// import { BsChatText } from 'react-icons/bs'
// import '../css/blog.css';
// function Blog() {
//     return (
//         <div className='home-ninth-section'>
//             <div className='ninth-container'>
//                 <div className='ninth-upper-container'>
//                     <h4>Our Blog</h4>
//                     <h2>Latest News & Update</h2>
//                     <p>There are many variations of passages of Lorem Ipsum available,
//                         but the majority have suffered alteration in some form,</p>
//                 </div>
//             </div>
//             <div className='ninth-lower-container'>
//                 <div className='ninth-lower-column-container'>
//                     <div className='ninth-lower-first-div'>
//                         <img src={UpperPic1} />
//                         <h2><a href="#">Giving The Poor Is A Great Satisfiction Of heart.</a></h2>
//                         <hr />
//                         {/* <div className='ninth-section-comments'>
//                             <img src={LowerPic1} />
//                             <p ><a href="#">Jenefer Willy</a></p>
//                             <p id='ninth-section-comments-template'> <BsChatText /> 35 </p>
//                         </div> */}
//                     </div>
//                     <div className='ninth-lower-second-div'>
//                         <img src={UpperPic2} />
//                         <h2><a href="#">Your Help Can Make Someone’s life Easier.</a></h2>
//                         <hr />
//                         {/* <div className='ninth-section-comments'>
//                             <img src={LowerPic2} />
//                             <p><a href="#">Laura Falary</a></p>
//                             <p id='ninth-section-comments-template'> <BsChatText /> 80 </p>
//                         </div> */}
//                     </div>
//                     <div className='ninth-lower-third-div'>
//                         <img src={UpperPic3} />
//                         <h2><a href="#">Give Education, It’s The Best Gift Ever.</a></h2>
//                         <hr />
//                         {/* <div className='ninth-section-comments'>
//                             <img src={LowerPic3} />
//                             <p><a href="#">Laura Falary</a></p>
//                             <p id='ninth-section-comments-template'> <BsChatText /> 95 </p>
//                         </div> */}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }
// export default Blog;


import React, { useEffect, useState } from "react";
import { blogData } from './Project'; // Adjust the path if needed
import { BsChatText } from 'react-icons/bs';
import { useNavigate } from "react-router-dom";
import '../css/blog.css';
import { Link } from "react-router-dom";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { motion } from "framer-motion";
function Blog() {


    const [activeIndex, setActiveIndex] = useState(0);
    const navigate = useNavigate();
    const handleNext = () => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % blogData.length);
    };
    const handleBlogClick = (id) => {
        navigate(`/blog/${id}`); // ✅ Pass blog data when navigating
    };


    const handlePrev = () => {
        setActiveIndex((prevIndex) =>
            prevIndex === 0 ? blogData.length - 1 : prevIndex - 1
        );
    };

    // Auto-slide functionality
    useEffect(() => {
      const autoSlide = setInterval(() => {
        handleNext();
      }, 5000); // Change slides every 5 seconds

      return () => clearInterval(autoSlide); // Cleanup on component unmount
    }, []);

    return (
        <div className="home-ninth-section">
            <div className="ninth-container">
                <div className="ninth-upper-container">
                    <h4>Our Blog</h4>
                    <h2>Latest News & Update</h2>
                    <p>
                        There are many variations of passages of Lorem Ipsum available, but the majority have
                        suffered alteration in some form.
                    </p>
                </div>
            </div>
            <div className="ninth-lower-container">
                <div className="ninth-lower-column-container">
                    {blogData.slice(activeIndex, activeIndex + 3).map((blog) => (
                        <motion.div
                            key={blog.id}
                            initial={{ opacity: 0, x: 50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5 }}
                            style={{
                                flex: "1",
                                minWidth: "300px",
                                maxWidth: "400px",
                                borderRadius: "12px",
                                overflow: "hidden",
                                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                textAlign: "center",
                                background: "#fff",
                                paddingBottom: "20px",

                            }}
                            onClick={() => handleBlogClick(blog.id)}
                        >
                            <div className="ninth-lower-div">
                                <img src={blog.image} alt={blog.title} />
                                <h2>
                                    <Link to={`/blog/${blog.id}`}>{blog.title}</Link>
                                </h2>
                                <p>{blog.description}</p>
                                <hr />
                            </div>
                        </motion.div>
                    ))}

{/*                    
                    <button
                        onClick={handlePrev}
                        className="blog-arrow left"
                    >
                        <FaArrowLeft size={30} color="#fff" />
                    </button>

          
                    <button
                        onClick={handleNext}
                        className="blog-arrow right"
                    >
                        <FaArrowRight size={30} color="#fff" />
                    </button> */}

                </div>

            </div>
        </div>
    );

}


export default Blog;
